import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './action';
import cn from 'classnames';

let table = { ...config };
table.url = '/wms/stockopname';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 130,
    component: (row) => {
      return <div className="text-ellipsis">{row?.code}</div>;
    },
  },

  created_by: {
    title: 'Dibuat Oleh',
    sortable: true,
    alias: 'created_at',
    width: 150,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold">{row?.created_by}</div>
          <small className="text-ellipsis">
            {formatDate(row?.created_at, 'DD/MM/YYYY')}
          </small>
        </div>
      );
    },
  },

  warehouse: {
    title: 'Warehouse',
    sortable: true,
    alias: 'warehouse.id',
    width: 150,
    component: (row) => {
      return <div className="text-ellipsis">{row?.warehouse?.name}</div>;
    },
  },

  type: {
    title: 'Tipe',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <div
          className={cn(
            'badge ms-auto',
            row?.type === 'opname' ? 'bg-primary-lt' : 'bg-yellow-lt'
          )}
        >
          {row?.type}
        </div>
      );
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
